module.exports = __webpack_public_path__ + "media/loader.36e241ef.mp4";